import React, { useState, useEffect, useRef } from "react";

const messages = [
  "Free shipping on orders over $50!",
  "Use code SAVE10 for 10% off your first order",
  "New arrivals every week — Shop now!",
];

export default function Header1() {
  const [current, setCurrent] = useState(0);
  const [direction, setDirection] = useState(null); // "left" | "right"
  const [animating, setAnimating] = useState(false);
  const intervalRef = useRef(null);

  const goTo = (next, dir) => {
    if (animating) return;
    setDirection(dir);
    setAnimating(true);
    setTimeout(() => {
      setCurrent(next);
      setAnimating(false);
    }, 350);
  };

  const goNext = () => {
    const next = (current + 1) % messages.length;
    goTo(next, "left");
    restartInterval();
  };

  const goPrev = () => {
    const next = (current - 1 + messages.length) % messages.length;
    goTo(next, "right");
    restartInterval();
  };

  const startInterval = () => {
    intervalRef.current = setInterval(() => {
      setCurrent((prev) => {
        const next = (prev + 1) % messages.length;
        setDirection("left");
        setAnimating(true);
        setTimeout(() => setAnimating(false), 350);
        return next;
      });
    }, 8000);
  };

  const restartInterval = () => {
    clearInterval(intervalRef.current);
    startInterval();
  };

  useEffect(() => {
    startInterval();
    return () => clearInterval(intervalRef.current);
  }, []);

  const slideStyle = {
    display: "inline-block",
    color: "white",
    fontWeight: "bold",
    fontSize: 14,
    transition: "opacity 0.35s ease, transform 0.35s ease",
    opacity: animating ? 0 : 1,
    transform: animating
      ? direction === "left"
        ? "translateX(-30px)"
        : "translateX(30px)"
      : "translateX(0px)",
  };

  const arrowStyle = {
    background: "none",
    border: "none",
    color: "white",
    fontSize: 20,
    cursor: "pointer",
    padding: "0 14px",
    lineHeight: 1,
    userSelect: "none",
    opacity: 0.85,
  };

  return (
    <div
      style={{
        height: 45,
        backgroundColor: "#1c1917",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
      }}
    >
      <button style={arrowStyle} onClick={goPrev} aria-label="Previous">
        &#8249;
      </button>

      <span style={{ width: 340, textAlign: "center", overflow: "hidden" }}>
        <span style={slideStyle}>{messages[current]}</span>
      </span>

      <button style={arrowStyle} onClick={goNext} aria-label="Next">
        &#8250;
      </button>
    </div>
  );
}
